import React from "react";
import { useLang } from "@/i18n";

export default function SellingUnit({ product, explain = false }) {
  const { t, lang } = useLang();
  if (!product?.selling_unit) return null;
  const unit = product.selling_unit;
  const custom = product[`selling_unit_label_${lang}`];
  const standard = t(`selling.sold.${unit}`);
  return <div className="my-1 break-words text-xs text-navy/80" data-testid="selling-unit">
    <p className="font-semibold">1 {t(`selling.unit.${unit}`)}</p>
    <p>{unit === "marmite" ? standard : custom || standard}</p>
    {unit === "marmite" && custom && custom !== standard && <p>{custom}</p>}
    {explain && unit === "marmite" && <p className="mt-1">{t("selling.photoNotice")}</p>}
  </div>;
}
